import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ReferralService {
  // Internal attribution is intentionally stricter than Google Ads' default
  // click-through window. This prevents a referral from claiming a booking
  // long after the original visit.
  private readonly COOKIE_DAYS = 14;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  initReferralID(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Read only the browser landing URL. The booking flow carries referralid
    // between Angular routes, so subscribing to route changes would refresh
    // the cookie merely because the visitor moves between booking steps.
    const params = new URLSearchParams(window.location.search);
    const rawRefid = params.get('referralid');
    const isUpsellReferral = params.get('upsell_applied') === 'extend_trip';

    // The Stay Longer referral describes this booking action only. It must
    // not replace the visitor's original referral attribution.
    if (rawRefid === null || isUpsellReferral) return;

    const cleanedRefid = this.stripLeadingZeros(rawRefid);
    this.setCookie('referralid', cleanedRefid, this.COOKIE_DAYS);
    console.log('Referral ID disimpan di cookie:', cleanedRefid);
  }

  getReferralId(): any {
    if (isPlatformBrowser(this.platformId)) {
      const ref = this.getCookie('referralid');
      return ref !== '' ? ref : 0;
    }
    return 0;
  }

  private stripLeadingZeros(value: string): string {
    return value.replace(/^0+/, '');
  }

  private setCookie(name: string, value: string, days: number): void {
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }

  private getCookie(name: string): string {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let c of ca) {
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return '';
  }
  clearReferralId(): void {
  if (isPlatformBrowser(this.platformId)) {
    document.cookie = 'referralid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    console.log('Referral ID dihapus dari cookie.');
  }
}
}
